<script setup lang="ts">
import type { CustomerQuizAnswer } from '@entities/customer'

import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'
import { CardAdmin } from '@shared/ui/cards'

defineOptions({
  name: 'CustomerQuizAnswers',
})

defineProps<{
  answers: CustomerQuizAnswer[]
}>()

const columns = [
  { title: 'Question title', className: 'customer-quiz-answers__wide' },
  { title: 'Answer title', className: 'customer-quiz-answers__wide' },
  { title: 'Question name', className: 'customer-quiz-answers__narrow' },
  { title: 'Answer name', className: 'customer-quiz-answers__narrow' },
]
</script>

<template>
  <CardAdmin
    title="Quiz answers"
    fullwidth
    class="customer-quiz-answers"
  >
    <AppTable
      class="rounded-table"
      :paginated="false"
    >
      <template #head>
        <AppTr>
          <AppTh
            v-for="column in columns"
            :key="column.title"
            :class="column.className"
          >
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              {{ column.title }}
            </AppText>
          </AppTh>
        </AppTr>
      </template>
      <template #body>
        <AppTr
          v-for="(answer, index) in answers"
          :key="`${answer.question_name}-${index}`"
        >
          <AppTd class="medium">
            <AppText name="body1">
              {{ answer.question_title }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <AppText name="body1">
              {{ Array.isArray(answer.answer_title) ? answer.answer_title.join(', ') : answer.answer_title }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <AppText name="body1">
              {{ answer.question_name }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <AppText name="body1">
              {{ answer.answer_name }}
            </AppText>
          </AppTd>
        </AppTr>
      </template>
    </AppTable>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./CustomerQuizAnswers.scss" />
